import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";
import type {
  FactProposalEditItem,
  FactProposalEditResult,
} from "@/types/chat.type";
import { brandUniverseChatProposalsKey } from "./useBrandUniverseChatProposals";
import { brandUniversePendingFactProposalsKey } from "./useBrandUniversePendingFactProposals";

/**
 * Edits the fact text of a still-pending proposal in place (same proposalId row,
 * no duplicate). Decided proposals are immutable — the server returns 409. On
 * success the proposals query is invalidated so the tray shows the edited text.
 */
export function useEditFactProposal(brandId: string, sessionId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: FactProposalEditItem) => {
      const res = await axiosInstance.patch<FactProposalEditResult>(
        `/brand-agent/${brandId}/sessions/${sessionId}/fact-proposal`,
        vars,
      );
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: brandUniverseChatProposalsKey(brandId, sessionId),
      });
      void queryClient.invalidateQueries({
        queryKey: brandUniversePendingFactProposalsKey(brandId),
      });
    },
  });
}
